import axios from "axios";
import { RefreshCw } from "lucide-react";
import "@/App.css";
import "@/lib/api"; // initialize axios defaults

import { API } from "./lib/api";
import { useAuthSession } from "./hooks/useAuthSession";
import LoginPage from "./components/dashboard/LoginPage";
import Dashboard from "./components/dashboard/Dashboard";
import ErrorBoundary from "./components/ErrorBoundary";

function App() {
  const { user, setUser, refresh } = useAuthSession();
  if (user === undefined) {
    return (
      <div className="login-shell">
        <div className="login-card">
          <RefreshCw className="spin" /> Loading...
        </div>
      </div>
    );
  }
  if (user === null) return <LoginPage onLogin={(u) => setUser(u)} />;
  return (
    <ErrorBoundary>
      <Dashboard
        authUser={user}
        onLogout={async () => {
          try { await axios.post(`${API}/auth/logout`); } catch { /* ignore */ }
          refresh();
        }}
      />
    </ErrorBoundary>
  );
}

export default App;
